import { useNavigate } from "react-router";
import { ILotteryUser, ILotteryUsersPagination } from "../../store/useLottery";
import { PrimaryButton } from "../../components";

interface LotteryUsersTableProps {
  users: ILotteryUser[];
  pagination: ILotteryUsersPagination;
  onPageChange: (page: number) => void;
  onLoadMore: () => void;
}

export const LotteryUsersTable = ({
  users,
  pagination,
  onPageChange,
  onLoadMore,
}: LotteryUsersTableProps) => {
  /** Hooks */
  const navigate = useNavigate();

  return (
    <>
      <div className="relative overflow-x-auto bg-white  border-gray-border drop-shadow-none rounded-xl">
        <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
          <thead className="font-medium bg-gray-50">
            <tr>
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
                First name
              </th>
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
                Last name
              </th>
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
                Email
              </th>
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
                Ticket count
              </th>
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {users?.length ? (
              users.map((user: ILotteryUser) => (
                <tr
                  key={user?._id}
                  className="bg-white hover:bg-gray-100 transition ease-linear border-b"
                >
                  <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                    {user?.first_name}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {user?.last_name}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">{user?.email}</td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {user?.ticketCount || 0} tickets
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                    <button
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(`/edit-user/${user?._id}`);
                      }}
                      className="text-blue-600 hover:text-blue-800 font-medium text-sm"
                    >
                      View User
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={5}
                  className="px-2 sm:px-6 py-1 sm:py-4 text-center text-gray-500"
                >
                  No participants found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Load More Button */}
      </div>

      {pagination?.hasNextPage ? (
        <div className="flex flex-row w-full bg-[#FFFAF8] items-center justify-end py-4 border-t">
          <PrimaryButton
            onClick={onLoadMore}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </>
  );
};
